/** Rows from GET/PUT `/integrations/linxup/group-labels` `groups` array. */
export type TallyGroupLabelApiRow = {
  id: number | string
  displayLabel: string
}

export function buildFleetIdLabelMap(groups: TallyGroupLabelApiRow[]): Map<number, string> {
  const m = new Map<number, string>()
  for (const g of groups) {
    const id = typeof g.id === 'number' ? g.id : Number(g.id)
    if (Number.isFinite(id) && g.displayLabel) m.set(id, g.displayLabel)
  }
  return m
}
